<div class="prog">
  <div id="cpuInfo">
    {{ (cpuLoad$ | async)?.toFixed(2) }} / {{ (overview$ | async)?.cpuCoreCountLogical }} {{ (overview$ | async)?.cpuCoreCountLogical | i18nPlural: systemLoadProcessorLabels | transloco }}
  </div>
  <div>{{ 'dashboardScope.dashboard.system-load.title_30' | transloco }}</div>
</div>
<avn-progressbar [showValue]="false" [showIcon]="false" [max]="(overview$ | async)?.cpuCoreCountLogical" [finished]="true">
  <avn-progress-segment [value]="cpuLoad$ | async" avnTheme="primary"></avn-progress-segment>
</avn-progressbar>

<div class="prog">
  <div id="memInfo">
    {{ (memPercent$ | async)?.toFixed(0) }}% / {{ (overview$ | async)?.memoryTotal - (overview$ | async)?.memoryAvailable | fileSize }} ({{ (overview$ | async)?.memoryTotal | fileSize }})
    <span *ngIf="(overview$ | async)?.memorySwapUsed > 0"> / Swap {{ (overview$ | async)?.memorySwapUsed | fileSize }}</span>
  </div>
  <div>{{ 'dashboardScope.dashboard.server.mem' | transloco }}</div>
</div>
<avn-progressbar [showValue]="false" [showIcon]="false" [max]="100" [finished]="true">
  <avn-progress-segment [value]="memPercent$ | async" avnTheme="secondary"></avn-progress-segment>
</avn-progressbar>

<div class="prog">
  <div id="diskInfo">
    {{ (diskPercent$ | async)?.toFixed(0) }}% / {{ (overview$ | async)?.diskTotal - (overview$ | async)?.diskAvailable | fileSize }} ({{ (overview$ | async)?.diskTotal | fileSize }})
  </div>
  <div>{{ 'dashboardScope.dashboard.server.disk' | transloco }}</div>
</div>
<avn-progressbar [showValue]="false" [showIcon]="false" [max]="100" [finished]="true">
  <avn-progress-segment [value]="diskPercent$ | async" avnTheme="info"></avn-progress-segment>
</avn-progressbar>

<div class="prog" style="margin-bottom: 20px">
  <div id="lanInfo">
    {{ (overview$ | async)?.networkReceive | fileSize }}/s
    <avn-icon [fontSize]="13" icon="fa:caret-down"></avn-icon>
    {{ (overview$ | async)?.networkSend | fileSize }}/s
    <avn-icon [fontSize]="13" icon="fa:caret-up"></avn-icon>
  </div>
  <div>{{ 'dashboardScope.dashboard.server.lan' | transloco }}</div>
</div>

<div class="prog" style="margin-bottom: 20px">
  <div id="uptimeInfo">
    {{ (overview$ | async)?.cpuUptimeFormatted }}
  </div>
  <div>{{ 'dashboardScope.dashboard.server.uptime' | transloco }}</div>
</div>

<div class="overview-badge">
  <section id="dbBadge" class="overview" [avnBackground]="{ cssProp: (overview$ | async)?.postgreDbIsAlive ? '--success-base' : '--danger-base', shade: 500 }">
    <span class="service-badge">{{ 'dashboardScope.dashboard.server.db' | transloco }}</span>
    <avn-icon icon="fa:database" [fontSize]="20"></avn-icon>
  </section>
  <section id="adBadge" class="overview" [avnBackground]="{ cssProp: (overview$ | async)?.cmAnalyticsDBIsAlive ? '--success-base' : '--danger-base', shade: 500 }">
    <div class="service-badge">{{ 'dashboardScope.dashboard.server.analytics-database' | transloco }}</div>
    <avn-icon icon="fa:database" [fontSize]="20"></avn-icon>
  </section>
  <section id="msBadge" class="overview" [avnBackground]="{ cssProp: (overview$ | async)?.monitoringServiceIsAlive ? '--success-base' : '--danger-base', shade: 500 }">
    <div class="service-badge">{{ 'dashboardScope.dashboard.server.monitoring-service' | transloco }}</div>
    <avn-icon icon="fa:line-chart" [fontSize]="20"></avn-icon>
  </section>
</div>
